import { Link } from 'react-router-dom';
import profile from '../../assets/images/profile.png';
import React, { useCallback, useState } from 'react';
import { SettingsIcon } from '@chakra-ui/icons';
import useSectionPermission from '../../hooks/useSectionPermission';
import UpdateSalaryModal from '../../pages/Employees/updateSalary';
import {
  Text,
  Card,
  CardBody,
  Avatar,
  Stack,
  Box,
  Tag,
  TagLabel,
  Badge,
  IconButton,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
} from '@chakra-ui/react';
import SlackModal from '../../pages/Employees/SlackModel';

type EmployeeCardProps = {
  name: string | undefined;
  user_id: string | undefined;
  email: string | undefined;
  userRole: string | undefined;
  currentUserRole: string | undefined;
  currentUserId: string | undefined;
  verified: string | undefined;
  setAdminOption: React.Dispatch<React.SetStateAction<string>>;
  setProfileUser: React.Dispatch<React.SetStateAction<any>>;
  setModalState: React.Dispatch<React.SetStateAction<boolean>>;
  modalState: boolean;
  assigned_HR: string | undefined;
  assigned_Manager: string | undefined;
  documents: any[];
  dob: Date;
  mobile: number;
  emergency_contact: number;
  permanentAddress: string;
  presentAddress: string;
  leave_data: any[];
  filterBy: string;
  setSelectedOption: any;
  selectedOption: any;
  isActive: boolean;
  designation: string;
  avatar: string | undefined;
};

export const getColorScheme = (designation: string): string => {
  const normalizedDesignation = designation?.toLowerCase();
  if (
    normalizedDesignation?.includes('marketing') ||
    normalizedDesignation?.includes('design')
  ) {
    return 'blue';
  }
  if (
    normalizedDesignation?.includes('developer') ||
    normalizedDesignation?.includes('software') ||
    normalizedDesignation?.includes('blockchain')
  ) {
    return 'cyan';
  }
  if (
    normalizedDesignation?.includes('sales') ||
    normalizedDesignation?.includes('social media') ||
    normalizedDesignation?.includes('editor')
  ) {
    return 'purple';
  }
  switch (normalizedDesignation) {
    default:
      return 'purple';
  }
};

const EmployeeCard = ({
  name,
  email,
  user_id,
  userRole,
  currentUserId,
  verified,
  setAdminOption,
  setProfileUser,
  setModalState,
  modalState,
  assigned_HR,
  assigned_Manager,
  documents,
  permanentAddress,
  presentAddress,
  dob,
  designation,
  mobile,
  emergency_contact,
  leave_data,
  isActive,
  avatar,
}: EmployeeCardProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isModal, setIsModal] = useState(false);
  const onClose = () => setIsModal(false);
  const {
    create,
    update,
    delete: deletePerm,
  } = useSectionPermission('employees');

  const setChangeRoleOption = () => {
    setModalState(!modalState);
    setAdminOption('change_user_details');
    setProfileUser({
      _id: user_id,
      name: name,
      email: email,
      role: userRole,
      verified,
      assigned_HR,
      assigned_Manager,
    });
  };

  const setDetailsOption = () => {
    setModalState(!modalState);
    setAdminOption('details');
    setProfileUser({
      _id: user_id,
      name: name ?? email,
      email: email,
      role: userRole,
      verified,
      assigned_HR,
      assigned_Manager,
      documents,
      permanentAddress,
      presentAddress,
      mobile,
      emergency_contact,
      dob,
    });
  };

  const setVerifyOption = () => {
    setModalState(!modalState);
    setAdminOption('verify_user');
    setProfileUser({
      _id: user_id,
      name: name ?? email,
      email: email,
      role: userRole,
      verified,
      assigned_HR,
      assigned_Manager,
      documents,
    });
  };

  const setLeaveEditOption = () => {
    setModalState(!modalState);
    setAdminOption('leave_edit');
    setProfileUser({
      _id: user_id,
      name: name ?? email,
      email: email,
      role: userRole,
      verified,
      assigned_HR,
      assigned_Manager,
      documents,
      leave_data,
    });
  };

  const setDeleteOption = useCallback(() => {
    setModalState(!modalState);
    setAdminOption('delete_option');
    setProfileUser({
      _id: user_id,
      name: name ?? email,
      email: email,
      role: userRole,
      verified,
      assigned_HR,
      assigned_Manager,
      documents,
      leave_data,
    });
  }, []);

  const setActiavteDeactivateOption = useCallback(() => {
    setModalState(!modalState);
    setAdminOption('update_option');
    setProfileUser({
      _id: user_id,
      name: name ?? email,
      email: email,
      role: userRole,
      verified,
      assigned_HR,
      assigned_Manager,
      documents,
      leave_data,
      isActive,
    });
  }, []);

  return (
    <div className="h-auto w-full">
      <Card
        className="relative flex items-center justify-between h-fit w-full"
        variant="outline"
        size="sm"
        direction="row"
        mt={2}
        shadow={'md'}
        borderRadius={'md'}
        
      >
        <CardBody
          display="flex"
          flexDirection={'row'}
          justifyContent={'space-between'}
          padding={0}
          px={4}
          py={2}
          w="full"
          alignItems={'center'}
        >
          <Stack direction="row" w="full" spacing={4} alignItems={'center'}>
            <Box position={'relative'} flexDirection={'row'} display={'flex'}>
              {/* .profile__img → w-[70px] h-[70px] object-contain rounded-full */}
              <Avatar
                name={name}
                src={avatar || profile}
                size="lg"
                className="w-[70px] h-[70px] object-contain rounded-full"
              />
            </Box>
            <Stack spacing={1} w="full">
              <Link to={`/dashboard/profile?_id=${user_id}`}>
                <Text
                  fontFamily="Poppins"
                  fontSize="14px"
                  textTransform={'capitalize'}
                  fontWeight="400"
                  lineHeight="21px"
                  gap={1}
                >
                  {name ?? email}
                  <Tag
                    size={'sm'}
                    ml={1}
                    colorScheme={
                      verified === 'true'
                        ? 'green'
                        : verified === 'false'
                        ? 'red'
                        : 'yellow'
                    }
                    borderRadius="full"
                    alignItems={'center'}
                    justifyContent={'center'}
                    variant={'outline'}
                  >
                    <TagLabel
                      fontFamily="Poppins"
                      fontSize="10px"
                      fontWeight="400"
                      lineHeight="16.5px"
                    >
                      {verified === 'true'
                        ? 'Verified'
                        : verified === 'false'
                        ? 'Unverified'
                        : 'Pending'}
                    </TagLabel>
                  </Tag>
                </Text>
              </Link>

              <Box>
                <Badge
                  fontFamily="Poppins"
                  fontWeight="500"
                  fontSize="10px"
                  lineHeight="15px"
                  size="10px"
                  colorScheme={getColorScheme(designation)}
                  alignItems="center"
                  justifyContent="center"
                  variant="subtle"
                >
                  {designation || userRole}
                </Badge>
              </Box>
            </Stack>
          </Stack>

          {/* .employee__card__admin__options → right-[10px] */}
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="center"
            gap={1}
            className="right-[10px]"
          >
            <Menu>
              {/* .employee__options__button → bg-transparent outline-none border-none cursor-pointer text-xl */}
              <MenuButton
                as={IconButton}
                aria-label="Options"
                icon={<SettingsIcon />}
                variant="ghost"
                color="#6E3EF5"
                className="bg-transparent outline-none border-none cursor-pointer text-xl"
              />
              <MenuList fontFamily="Poppins" fontSize="13px">
                {update && currentUserId !== user_id && (
                  <MenuItem onClick={setChangeRoleOption}>Manage Access</MenuItem>
                )}
                {create && update && (
                  <MenuItem onClick={() => setIsOpen(true)} >
                    Slack ID{' '}
                    <SlackModal
                      isOpen={isOpen}
                      setIsOpen={setIsOpen}
                      user_id={user_id}
                      email={email}
                      name={name}
                    />
                  </MenuItem>
                )}
                {create && update && (
                  <MenuItem onClick={() => setIsModal(true)}>
                    Salary Info{' '}
                    <UpdateSalaryModal
                      isOpen={isModal}
                      onClose={onClose}
                      user_id={user_id}
                    />
                  </MenuItem>
                )}
                {update && (
                  <MenuItem onClick={setLeaveEditOption}>Edit Leaves</MenuItem>
                )}
                {verified !== 'false' && update && (
                  <MenuItem onClick={setDetailsOption}>View Details</MenuItem>
                )}
                {(verified === 'pending' || verified === 'false') && update && (
                  <MenuItem onClick={setVerifyOption}>Verify User</MenuItem>
                )}
                {deletePerm &&
                  currentUserId !== user_id &&
                  (verified === 'true' ? (
                    isActive ? (
                      <MenuItem onClick={setActiavteDeactivateOption}>
                        Disable User
                      </MenuItem>
                    ) : null
                  ) : (
                    <MenuItem onClick={setDeleteOption}>Delete User</MenuItem>
                  ))}
              </MenuList>
            </Menu>
          </Stack>
        </CardBody>
      </Card>
    </div>
  );
};

export default React.memo(EmployeeCard, (prevProps, nextProps) => {
  if (prevProps.documents !== nextProps.documents) {
    return true;
  } else {
    return false;
  }
});
